<div class="db-hosting-info">
  <div class="db-hosting-info-wrap">
    <ds-mobile-page-title class="ds-mobile-page-title-centered"></ds-mobile-page-title>
    <div class="db-hosting-body-wrap" dbCustomScrollbar id="db-hosting-info">
      <div class="db-hosting-body-blocks"  [ngClass]="{'db-page-with-banner': hasHostingBanner}">
        <div class="db-hosting-block db-panel_flex">
          <div class="db-panel__header">
            <div>{{'text_hostingBasicInfoTitle' | dbText}}</div>
            <div class="info-icon-wrap"  [dsTooltipPosition]="'bottom'" [dsTooltip]="'text_credentials.IP.desc' | dbText"><i class="db-icon db-icon-info-lined"></i></div>
          </div>
          <div class="db-panel__body">
            <div class="db-hosting-block-item db-hosting-info__with-border">
              <div>{{'text_hostingBasicInfoLocation' | dbText}}</div>
              <div class="sl-basic-info-location">{{hostingInfoData.hostingBasicInfo.location}}</div>
            </div>
            <div class="db-hosting-block-item basic-info">
              <div [innerHTML]="'text_hostingBasicInfoIp' | dbText"></div>
              <div class="sl-basic-info-ip">{{hostingInfoData.hostingBasicInfo.ip}}</div>
            </div>
          </div>
        </div>
        <div class="db-hosting-block db-panel_flex">
          <div class="db-panel__header">
            <div>{{'text_hostingSftpTitle' | dbText}}</div>
            <div class="info-icon-wrap"
                 [dsTooltipPosition]="'bottom'"
                 [dsTooltip]="'text_howToUseSftpInfoTooltipDesc' | dbText"><i class="db-icon db-icon-info-lined"></i></div>
          </div>
          <div class="db-panel__body">
            <div class="db-sftp-block-trial" *ngIf="hostingInfoData && hostingInfoData.hostingSftp && !hostingInfoData.hostingSftp.username">
              <div>
                <span>{{'text_howToUseSftpInfoTooltipDescShort' | dbText}}</span>
                <div class="db-hosting-info__upgrade">
                  <span *ngIf="hideUpgradeButton">{{'text_featureAvailableToPaidPlans' | dbText}}<br/>{{'text_contactWorkspaceOwner' | dbText}}</span>
                  <span *ngIf="!hideUpgradeButton">
                    <a (click)="showCheckoutDialog('Dashboard: Get SFTP credentials')" class="db-link"><span>{{'text_accessThisFeature' | dbText}}</span></a>
                  </span>
                </div>
              </div>
            </div>
            <div class="db-sftp-block-hosting" *ngIf="hostingInfoData && hostingInfoData.hostingSftp && hostingInfoData.hostingSftp.username">
              <div class="db-hosting-block-item db-hosting-info__with-border">
                <div>{{'text_hostingSftpHost' | dbText}}</div>
                <div>
                  <div class="sl-sftp-info-site-url">{{hostingInfoData.hostingBasicInfo.ip}}</div>
                  <div>
                    <div>
                      <input type="text" class="form-control" [value]="hostingInfoData.hostingBasicInfo.ip" #inputTargetSftpHost readonly>
                      <a class="db-hosting-info__icon" [ngxClipboard]="inputTargetSftpHost"
                         (cbOnSuccess)="copiedSftpHost()"
                         [dsTooltipPosition]="'top'"
                         [dsTooltip]="'text_copy' | dbText"
                         *ngIf="!isCopiedSftpHost">
                        <i class="db-icon db-icon-copy"></i>
                      </a>
                      <a class="db-hosting-info__icon" *ngIf="isCopiedSftpHost"
                         [dsTooltipPosition]="'top'"
                         [dsTooltip]="'text_copied' | dbText"  >
                        <i class="db-icon db-icon-copy"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="db-hosting-block-item db-hosting-info__with-border">
                <div>{{'text_hostingSftpUsername' | dbText}}</div>
                <div>
                  <div class="sl-sftp-info-username">{{hostingInfoData.hostingSftp.username}}</div>
                  <div>
                    <div>
                      <input type="text" class="form-control" [value]="hostingInfoData.hostingSftp.username" #inputTargetSftpUsername readonly>
                      <a class="db-hosting-info__icon" [ngxClipboard]="inputTargetSftpUsername" (cbOnSuccess)="copiedSftpUsername()"

                         [dsTooltipPosition]="'top'" [dsTooltip]="'text_copy' | dbText"
                         *ngIf="!isCopiedSftpUsername">
                        <i class="db-icon db-icon-copy"></i>
                      </a>
                      <a class="db-hosting-info__icon" *ngIf="isCopiedSftpUsername"    [dsTooltipPosition]="'top'" [dsTooltip]="'text_copied' | dbText"  >
                        <i class="db-icon db-icon-copy"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="db-hosting-block-item db-hosting-info__with-border">
                <div>{{'text_hostingSftpPassword' | dbText}}</div>
                <div class="db-hosting-info__password-wrap">
                  <div class="sl-sftp-info-password">
                    <span *ngIf="showPassword">{{hostingInfoData.hostingSftp.password}}</span>
                    <p *ngIf="!showPassword">..................</p>
                  </div>

                  <div>
                    <div>
                      <input type="text" class="form-control" [value]="hostingInfoData.hostingSftp.password" #inputTargetSftpPassword readonly>
                      <a class="db-hosting-info__icon" [ngxClipboard]="inputTargetSftpPassword" (cbOnSuccess)="copiedSftpPassword()"   [dsTooltipPosition]="'top'" [dsTooltip]="'text_copy' | dbText"
                         *ngIf="!isCopiedSftpPassword">
                        <i class="db-icon db-icon-copy"></i>
                      </a>
                      <a class="db-hosting-info__icon" *ngIf="isCopiedSftpPassword"    [dsTooltipPosition]="'top'" [dsTooltip]="'text_copied' | dbText"  >
                        <i class="db-icon db-icon-copy"></i>
                      </a>
                    </div>
                    <i class="db-icon db-icon-eye" *ngIf="!showPassword" (click)="togglePassword()" [title]="'text_showPassword' | dbText"></i>
                    <i class="db-icon db-icon-eye-hide" *ngIf="showPassword" (click)="togglePassword()" [title]="'text_hidePassword' | dbText"></i>
                  </div>
                </div>
              </div>
              <div class="db-hosting-block-item ">
                <div>{{'text_hostingSftpPort' | dbText}}</div>

                <div>
                  <div class="sl-sftp-info-port">{{hostingInfoData.hostingSftp.port}}</div>
                  <div>
                    <input type="text" class="form-control" [value]="hostingInfoData.hostingSftp.port" #inputTargetSftpPort readonly>
                    <a class="db-hosting-info__icon" [ngxClipboard]="inputTargetSftpPort" (cbOnSuccess)="copiedSftpPort()"   [dsTooltipPosition]="'top'" [dsTooltip]="'text_copy' | dbText"
                       *ngIf="!isCopiedSftpPort">
                      <i class="db-icon db-icon-copy"></i>
                    </a>
                    <a class="db-hosting-info__icon" *ngIf="isCopiedSftpPort"    [dsTooltipPosition]="'top'" [dsTooltip]="'text_copied' | dbText"  >
                      <i class="db-icon db-icon-copy"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div class="db-hosting-block-item db-hosting-info__button-wrap">
                <a class="ds-btn ds-btn-max ds-btn-black sl-sftp-info-generate-password" (click)="generatePasswordClicked('sftp')">
                  <span>{{'text_hostingDatabaseSftp' | dbText | lowerCaseSpecificWords}}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="db-hosting-block db-panel_flex">
          <div class="db-panel__header">
            <div>{{'text_hostingDatabaseTitle' | dbText}}</div>
            <div class="info-icon-wrap"   [dsTooltipPosition]="'bottom'" [dsTooltip]="'text_credentials.Database.Desc' | dbText"><i class="db-icon db-icon-info-lined"></i></div>
          </div>
          <div class="db-panel__body">
            <div class="db-hosting-block-trial" *ngIf="hostingInfoData && hostingInfoData.hostingDatabase && !hostingInfoData.hostingDatabase.username">
              <div>
                <span>{{'text_howToUseDbInfoTooltipDescShort' | dbText}}</span>
                <div class="db-hosting-info__upgrade">
                  <span *ngIf="hideUpgradeButton">{{'text_featureAvailableToPaidPlans' | dbText}}<br/>{{'text_contactWorkspaceOwner' | dbText}}</span>
                  <span *ngIf="!hideUpgradeButton">
                    <a (click)="showCheckoutDialog('Dashboard: Get Database credentials')" class="db-link"><span>{{'text_accessThisFeature' | dbText}}</span></a>
                  </span>
                </div>
              </div>
            </div>
            <div *ngIf="hostingInfoData && hostingInfoData?.hostingDatabase && hostingInfoData?.hostingDatabase?.username">
              <div class="db-hosting-block-item db-hosting-info__with-border">
                <div>{{'text_hostingDatabaseName' | dbText}}</div>
                <div class="sl-database-info-db-name">{{hostingInfoData.hostingDatabase.name}}</div>
              </div>
              <div class="db-hosting-block-item db-hosting-info__with-border">
                <div>{{'text_hostingDatabaseUsername' | dbText}}</div>
                <div>
                  <div class="sl-database-info-username">{{hostingInfoData.hostingDatabase.username}}</div>
                  <div>
                    <a class="db-hosting-info__icon" ngxClipboard [cbContent]="hostingInfoData.hostingDatabase.username"  (cbOnSuccess)="copiedDatabaseUsername()"   [dsTooltipPosition]="'top'" [dsTooltip]="'text_copy' | dbText"
                       *ngIf="!isCopiedDatabaseUsername">
                      <i class="db-icon db-icon-copy"></i>
                    </a>
                    <a class="db-hosting-info__icon" *ngIf="isCopiedDatabaseUsername"    [dsTooltipPosition]="'top'" [dsTooltip]="'text_copied' | dbText"  >
                      <i class="db-icon db-icon-copy"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div class="db-hosting-block-item ">
                <div>{{'text_hostingDatabasePassword' | dbText}}</div>
                <div class="db-hosting-info__password-wrap">
                  <div>
                    <span *ngIf="showDbPassword" class="sl-database-info-password">{{hostingInfoData.hostingDatabase.password}}</span>
                    <p *ngIf="!showDbPassword">..................</p>
                  </div>
                  <div>
                    <div>
                      <input type="text" class="form-control" [value]="hostingInfoData.hostingDatabase.password" #inputTargetDatabase readonly>
                      <a class="db-hosting-info__icon" [ngxClipboard]="inputTargetDatabase" (cbOnSuccess)="copiedDatabasePassword()"  [dsTooltipPosition]="'top'" [dsTooltip]="'text_copy' | dbText"
                         *ngIf="!isCopiedDatabasePassword">
                        <i class="db-icon db-icon-copy"></i>
                      </a>
                      <a class="db-hosting-info__icon" *ngIf="isCopiedDatabasePassword"  [dsTooltipPosition]="'top'" [dsTooltip]="'text_copied' | dbText"  >
                        <i class="db-icon db-icon-copy"></i>
                      </a>
                    </div>
                    <i class="db-icon db-icon-eye" *ngIf="!showDbPassword" (click)="toggleDbPassword()" [title]="'text_showPassword' | dbText"></i>
                    <i class="db-icon db-icon-eye-hide" *ngIf="showDbPassword" (click)="toggleDbPassword()" [title]="'text_hidePassword' | dbText"></i>
                  </div>
                </div>
              </div>
              <div class="db-hosting-block-item db-hosting-info__button-wrap db-hosting-info__open-mysql">
                <a class="ds-btn ds-btn-max ds-btn-black sl-database-info-open-mysql" target="_blank" rel="noopener"
                    [href]="hostingPhpAdminAutologin" (click)="openSql()">
                  <span>{{'text_hostingDatabaseButton' | dbText | lowerCaseSpecificWords}}</span>
                </a>
                <a class="open-mysql sl-database-info-open-mysql mt10"
                   (click)="generatePasswordClicked('mysql')">
                  <span>{{ 'text_regenerateMySQLPassword' | dbText }}</span>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div class="db-hosting-block db-panel_flex">
          <div class="db-panel__header">
            <div>{{'text_hostingSSHTitle' | dbText}}</div>
            <div class="info-icon-wrap"   [dsTooltipPosition]="'bottom'" [dsTooltip]="'text_credentials.SSH.Desc' | dbText"><i class="db-icon db-icon-info-lined"></i></div>
          </div>
          <div class="db-panel__body" [ngClass]="{'db-ssh-trial': hostingInfoData && hostingInfoData.hostingSftp && hostingInfoData.hostingSftp.username}">
            <div class="db-hosting-info__ssh-block-trial" *ngIf="hostingInfoData && hostingInfoData.hostingSftp && !hostingInfoData.hostingSftp.username">
              <div class="db-ssh-block-hosting-body">
                <span [innerHTML]="'text_SSHDescShort' | dbText"></span>
                <div class="db-hosting-info__upgrade">
                  <span *ngIf="hideUpgradeButton">{{'text_featureAvailableToPaidPlans' | dbText}}<br/>{{'text_contactWorkspaceOwner' | dbText}}</span>
                  <span *ngIf="!hideUpgradeButton">
                    <a (click)="showCheckoutDialog('Dashboard: Get SSH credentials')" class="db-link"><span>{{'text_accessThisFeature' | dbText}}</span></a>
                  </span>
                </div>
              </div>
            </div>
            <div *ngIf="hostingInfoData && hostingInfoData.hostingSftp && hostingInfoData.hostingSftp.username" class="db-ssh-block-hosting">
              <div class="db-ssh-block-hosting-body">
                <div class="db-hosting-ssh-block-item db-hosting-info__with-border">
                  <p class="db-ssh-desc-sec" [innerHTML]="'text_hostingSSHDesc' | dbText"></p>
                </div>
                <div class="db-hosting-ssh-block-item db-hosting-info__with-border">
                  <div>{{'text_hostingSSHCommandLine' | dbText}}</div>
                  <div>
                    <div class="db-ssh-command-line">ssh {{hostingInfoData.hostingSftp.username}}{{'@'}}{{hostingInfoData.hostingBasicInfo.ip}} -p {{hostingInfoData.hostingSftp.port}}</div>
                    <div>
                      <input type="text" class="form-control" [ngModel]="'ssh '+hostingInfoData.hostingSftp.username+'@'+hostingInfoData.hostingBasicInfo.ip+' -p '+hostingInfoData.hostingSftp.port" #inputTargetSSH>
                     <a class="db-hosting-info__icon" [ngxClipboard]="inputTargetSSH" (cbOnSuccess)="copiedSSH()"   [dsTooltipPosition]="'top'" [dsTooltip]="'text_copy' | dbText"
                        *ngIf="!isCopiedSSH">
                       <i class="db-icon db-icon-copy"></i>
                  </a>
                      <a class="db-hosting-info__icon" *ngIf="isCopiedSSH"    [dsTooltipPosition]="'top'" [dsTooltip]="'text_copied' | dbText"  >
                        <i class="db-icon db-icon-copy"></i>
                      </a>
                    </div>
                  </div>
                </div>
                <div class="db-hosting-ssh-block-item">
                  <div>{{'text_hostingSSHPassword' | dbText}}</div>
                  <div class="db-hosting-info-block-item__password-wrap db-hosting-info__password-wrap">
                    <div>
                      <span *ngIf="showSSHPassword">{{hostingInfoData.hostingSftp.password}}</span>
                      <p *ngIf="!showSSHPassword">..................</p>
                    </div>
                    <div>
                      <div>
                        <input type="text" class="form-control" [value]="hostingInfoData.hostingSftp.password" #inputTargetSftpPassword readonly>
                        <a class="db-hosting-info__icon" [ngxClipboard]="inputTargetSftpPassword" (cbOnSuccess)="copiedSftpPassword()"   [dsTooltipPosition]="'top'" [dsTooltip]="'text_copy' | dbText"
                           *ngIf="!isCopiedSftpPassword">
                          <i class="db-icon db-icon-copy"></i>
                        </a>
                        <a class="db-hosting-info__icon" *ngIf="isCopiedSftpPassword"    [dsTooltipPosition]="'top'" [dsTooltip]="'text_copied' | dbText"  >
                          <i class="db-icon db-icon-copy"></i>
                        </a>
                      </div>
                      <i class="db-icon db-icon-eye" *ngIf="!showSSHPassword" (click)="toggleSSHPassword()" [title]="'text_showPassword' | dbText"></i>
                      <i class="db-icon db-icon-eye-hide" *ngIf="showSSHPassword" (click)="toggleSSHPassword()" [title]="'text_hidePassword' | dbText"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
